import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=10b0e9de&scoped=true&"
import script from "./Leaderboard.vue?vue&type=script&lang=js&"
export * from "./Leaderboard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/leaderboard.scss?vue&type=style&index=0&id=10b0e9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0e9de",
  null
  
)

export default component.exports